import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {DomSanitizer} from '@angular/platform-browser';
import {ClientService} from '../services/client.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {BreakpointObserver} from '@angular/cdk/layout';
import {Router} from '@angular/router';
import {TrsService} from '@core-app/services/trs.service';


@Component({
    template: '',
    standalone: false
})
export class BlockStatementAbstractComponent extends BlockAbstractComponent implements OnInit {
    modalRef!: BsModalRef;
    authUser: any;
    isPrintPDFRoute!: boolean;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected sanitizer: DomSanitizer,
        protected client: ClientService,
        protected trsService: TrsService,
        protected breakpoint: BreakpointObserver,
        protected modalService?: BsModalService,
        protected router?: Router
    ) {
        super(
            parser,
            auth,
        );
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.authUser = this.auth.user;
        this.isPrintPDFRoute = this.trsService.isPrintRoute();
    }

    formatDataToLowercaseNoSpacesWithHyphens(type: any) {
        return type.toLowerCase().replace(/\s/g, '-');
    }

}
